// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Shell.test.tsx
import { Heading, Text } from "@radix-ui/themes";
import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import {
  ASK_V2_CHATS_PATH,
  ASK_V2_HOME_PATH,
  ASK_V2_PROJECTS_PATH,
} from "../paths";

/**
 * V2 product chrome. Isolated from `/ask-puntt` and the tickets layout.
 * Page bodies render through the outlet.
 */
export function AskV2Shell() {
  const { t } = useTranslation("ui");

  return (
    <main
      data-testid="ask-v2-shell"
      aria-label={t("askV2.shell.title")}
      className="flex min-h-screen flex-col bg-base-white"
    >
      <header className="flex flex-col gap-1 border-b border-puntt-neutral-gray-6 px-6 py-4">
        <Heading as="h1" size="5" data-testid="ask-v2-shell-title">
          {t("askV2.shell.title")}
        </Heading>
        <Text
          as="p"
          size="2"
          data-testid="ask-v2-shell-subtitle"
          className="text-puntt-neutral-gray-11"
        >
          {t("askV2.shell.subtitle")}
        </Text>
      </header>
      <nav
        data-testid="ask-v2-nav"
        aria-label={t("askV2.nav.label")}
        className="flex gap-4 border-b border-puntt-neutral-gray-6 px-6 py-2"
      >
        <Link to={ASK_V2_HOME_PATH} data-testid="ask-v2-nav-home">
          {t("askV2.nav.home")}
        </Link>
        <Link to={ASK_V2_CHATS_PATH} data-testid="ask-v2-nav-chats">
          {t("askV2.nav.chats")}
        </Link>
        <Link to={ASK_V2_PROJECTS_PATH} data-testid="ask-v2-nav-projects">
          {t("askV2.nav.projects")}
        </Link>
      </nav>
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
    </main>
  );
}
